import styled from "styled-components";

export const Label = styled.p`
    ${(props) => props.theme.fonts.variant.regular()};
    font-size: 0.8750em;
`;